import React from "react";
import { useTranslation } from "react-i18next";

export default function MobileMenu(props) {
    const { t } = useTranslation();
    const { setStepByIndex, currentPart, partIndex, partList, completeSteps } = props;

    const refMenu = React.useRef();
    const refList = React.useRef();

    React.useEffect(() => {
        const domList = refList.current;

        domList.addEventListener("scroll", onDomListScroll);
        domList.addEventListener("mousewheel", onDomListMouseWheel);

        return () => {
            domList.removeEventListener("scroll", onDomListScroll);
            domList.removeEventListener("mousewheel", onDomListMouseWheel);
        };
    }, [refList]);

    React.useEffect(() => {
        if (!refList.current) {
            return;
        }

        const pi = partIndex(currentPart);

        const domList = refList.current;
        const domitems = domList.querySelectorAll(".wizard-mobile-menu-item");
        const selectedMenuitem = domitems[pi];

        if (!selectedMenuitem) {
            return;
        }

        const offsetsNwidths = Object.values(domitems).map(domMenuItem => {
            return { offsetLeft: domMenuItem.offsetLeft, width: domMenuItem.offsetWidth };
        });

        domitems.forEach(item => item.classList.remove("selected"));
        selectedMenuitem.classList.add("selected");

        domList.scrollLeft = offsetsNwidths[pi].offsetLeft - domList.offsetWidth / 2 + offsetsNwidths[pi].width / 2;

        domList.dispatchEvent(new Event("scroll"));
    }, [currentPart]);

    function onDomListScroll() {
        const domList = refList.current;
        const domMenu = refMenu.current;
        const domLeft = domMenu.querySelector(".wizard-mobile-menu-left");
        const domRight = domMenu.querySelector(".wizard-mobile-menu-right");

        domLeft.classList.toggle("show", domList.scrollLeft > 10);
        domRight.classList.toggle("show", domList.scrollLeft + domList.offsetWidth < domList.scrollWidth - 10);
    }

    function onDomListMouseWheel(event) {
        if (!event.wheelDeltaY) {
            return null;
        }

        const domList = refList.current;

        domList.scrollLeft -= event.wheelDeltaY;
    }

    return (
        <div ref={refMenu} className="wizard-mobile-menu prevent-select">
            <div className="wizard-mobile-menu-left"></div>

            <div ref={refList} className="wizard-mobile-menu-list">
                {partList.map((step, index) => (
                    <div
                        key={step.key}
                        className={`wizard-mobile-menu-item ${completeSteps[index]?.fullfilled ? "completed" : ""}`}
                        data-index={index}
                        data-step-name={step.menuKey}
                        onClick={() => setStepByIndex(index)}
                    >
                        {t(`${step.menuKey}`)}
                    </div>
                ))}
            </div>

            <div className="wizard-mobile-menu-right"></div>
        </div>
    );
}
